import { ref } from '@vue/composition-api'

import useRequest from '@/compositions/useRequest'

import EventsView from '@/components/EventsView'

export default {
  components: { EventsView },
  setup(props, context) {
    const { $store } = context.root
    const { id } = context.root.$route.params
    const events = ref([])

    const { makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('orders/fetchEvents', { id }),
    })

    const init = async () => {
      events.value = await makeRequest()
    }

    init()

    return {
      events,
    }
  },
}
